import React from 'react';
import NotificationCount from '../notification-count';
import { AvatarSC } from './avatar.styled';

type TAvatarProps = {
  imgUrl?: string | null;
  size?: number;
  isDoctor?: boolean;
  isBlocked?: boolean;
  notificationsCount?: number;
  onClick?(): any;
  style?: React.CSSProperties;
  className?: string;
};

const Avatar: React.FC<TAvatarProps> = ({
  notificationsCount,
  isDoctor,
  size,
  isBlocked,
  imgUrl,
  onClick,
  className,
  style,
}: TAvatarProps) => {
  return (
    <AvatarSC size={size} onClick={onClick} style={style} className={className}>
      <img src={imgUrl || require('../../assets/svg/avatar.svg').default} alt="" />
      <NotificationCount count={notificationsCount} className="avatar-notifications" />
      {isDoctor ? (
        <img
          className="avatar-check"
          src={require('../../assets/svg/icon-dr-mark.svg').default}
          alt=""
        />
      ) : null}
      {isBlocked ? (
        <img
          className="avatar-check"
          src={require('../../assets/svg/icon-blocked.svg').default}
          alt=""
        />
      ) : null}
    </AvatarSC>
  );
};

export default Avatar;
